import { runDemo } from "../shared/demoRunner";
import { createSoftShadowsScene } from "./scene";

runDemo({ createScene: createSoftShadowsScene });
